export const SET_PRIVACY_PAGE = "setPrivacyPage";
